import ReportStudiesTable from './ReportStudiesTable';

const Navigation = () => {    
    
    return (
        <div style={{ padding: 10, color: "white", backgroundColor: "#6B747F" }}>
            <ReportStudiesTable/>                    
        </div>

    );
};
export default Navigation;